/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceListNew
 */
export interface PriceListNew {
    /**
     * 
     * @type {string}
     * @memberof PriceListNew
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof PriceListNew
     */
    validFrom: Date;
}

/**
 * Check if a given object implements the PriceListNew interface.
 */
export function instanceOfPriceListNew(value: object): value is PriceListNew {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    return true;
}

export function PriceListNewFromJSON(json: any): PriceListNew {
    return PriceListNewFromJSONTyped(json, false);
}

export function PriceListNewFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceListNew {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'validFrom': (new Date(json['validFrom'])),
    };
}

export function PriceListNewToJSON(json: any): PriceListNew {
    return PriceListNewToJSONTyped(json, false);
}

export function PriceListNewToJSONTyped(value?: PriceListNew | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'validFrom': ((value['validFrom']).toISOString()),
    };
}

